import script from "./SignBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignBanner.vue?vue&type=script&lang=ts&setup=true"

import "./SignBanner.vue?vue&type=style&index=0&id=b9176dd2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9176dd2"]])

export default __exports__